(function () {
    'use strict';

    angular
        .module('advancedapp')
        .controller('SiteSearchController', SiteSearchController);

    SiteSearchController.$inject = ['$location', '$scope', 'search_service'];

    function SiteSearchController($location, $scope, search_service) {
        /* jshint validthis:true */
        var ctrl = this;
        ctrl.title = 'SiteSearchController';

        ctrl.init = init;
        ctrl.onCategoryChange = onCategoryChange;

        ctrl.toggleView = toggleView;
        ctrl.gridView = false;



        function onCategoryChange(model) {

           var criteria =  JSON.stringify(model);

             searchWithCats(criteria);
        }


        function init(data) {

            ctrl.results = data;
        }


        function searchWithCats(model) {

            //var searchUrl = 'search/search/';
            var searchUrl = 'search/';

            return search_service.search(searchUrl,model)
                .then(function (result) {
          
                    ctrl.results = result;

                    return result;
                });
        }

        function toggleView(value) {

            if (value == 'grid') {

                ctrl.gridView = true;
            }
            else {
                ctrl.gridView = false;
            }

        }

    }
})();
